/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginRequest } from '../models/LoginRequest';
import type { SuccessEnvelope_CurrentUserResponse_ } from '../models/SuccessEnvelope_CurrentUserResponse_';
import type { SuccessEnvelope_MessageResponse_ } from '../models/SuccessEnvelope_MessageResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Login
     * @param requestBody
     * @returns SuccessEnvelope_CurrentUserResponse_ Successful Response
     * @throws ApiError
     */
    public static loginApiV1AuthLoginPost(
        requestBody: LoginRequest,
    ): CancelablePromise<SuccessEnvelope_CurrentUserResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Validation Error`,
                503: `Service Unavailable`,
            },
        });
    }
    /**
     * Logout
     * @param xCsrfToken CSRF token for unsafe authenticated requests.
     * @returns SuccessEnvelope_MessageResponse_ Successful Response
     * @throws ApiError
     */
    public static logoutApiV1AuthLogoutPost(
        xCsrfToken?: string,
    ): CancelablePromise<SuccessEnvelope_MessageResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/logout',
            headers: {
                'X-CSRF-Token': xCsrfToken,
            },
            errors: {
                403: `Forbidden`,
                503: `Service Unavailable`,
            },
        });
    }
    /**
     * Me
     * @returns SuccessEnvelope_CurrentUserResponse_ Successful Response
     * @throws ApiError
     */
    public static meApiV1AuthMeGet(): CancelablePromise<SuccessEnvelope_CurrentUserResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/auth/me',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                503: `Service Unavailable`,
            },
        });
    }
}
